import { queryClient } from "@lobby/core/src";
import { createFileRoute } from "@tanstack/react-router";

import { loadGameCategoryList, loadGameList } from "app/lib/loaders";
import { GamePage } from "pages/game";

export const Route = createFileRoute("/_auth/game/$gameId")({
  beforeLoad: () => {
    queryClient.removeQueries({ queryKey: ["Game.run"] });
  },
  loader: () => Promise.all([loadGameCategoryList(), loadGameList()]),
  component: GamePage,
  onError: console.error,
});
